export default "__VITE_ASSET__3mFVP1Vi__"